// extracted by mini-css-extract-plugin
export var infoBox = "callout-module--infoBox--86iLs";
export var danger = "callout-module--danger--HRPE1";
export var info = "callout-module--info--cJbLA";
export var garden = "callout-module--garden--Z5Q8V";
export var book = "callout-module--book--N0MLR";